import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import {
  CreateResellerTargetCommand,
  GetResellerTargetByIdDto,
  ResellerTargetTimes,
  UpdateResellerTargetCommand,
} from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { PeriodicDateConfig } from 'src/app/shared/components/periodic-date-picker/periodic-date-picker.component';
import { ResellerTargetService } from '../../../../core/api/services/reseller-target.service';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';


@Component({
    selector: 'app-resellers-target-form',
    templateUrl: './resellers-target-form.component.html',
    imports: [BaseFormModule]
})

export class ResellersTargetFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  formPageConfig: FormPageConfig<GetResellerTargetByIdDto> = {};

  model: CreateResellerTargetCommand = {};
  periodicDateConfig: PeriodicDateConfig;

  get ResellerTargetTimes() {
    return ResellerTargetTimes;
  }

  //#endregion

  constructor(protected currentService: ResellerTargetService) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.setComponentsConfig();
    this.changeValidation();
  }

  changeValidation() {
    if (this.formPageConfig?.isEditMode) this.form.get('userId').disable();
  }

  setComponentsConfig() {
    try {
      this.periodicDateConfig = {
        startDateLabel: 'common.startDate',
        endDateLabel: 'common.endDate',
        startDateFormControl: this.form?.get('startDate') as FormControl,
        endDateFormControl: this.form?.get('endDate') as FormControl,
        responsiveClassName: 'sm:tw-w-1/2',
        minStartDateType: 'unlimited',
        isShowEndDate: true,
        isShowStartDate: true,
        startDateValue: this.model.startDateTime,
      };
      let isValidStartDate = DateTimeService.isValidUtcDateTime(
        this.formPageConfig?.editData?.startDateTime
      );
      let isValidEndDate = DateTimeService.isValidUtcDateTime(
        this.formPageConfig?.editData?.endDateTime
      );

      if (this.formPageConfig.isEditMode) {
        this.periodicDateConfig.startDateValue = isValidStartDate
          ? this.formPageConfig?.editData?.startDateTime
          : '';
        this.periodicDateConfig.endDateValue = isValidEndDate
          ? this.formPageConfig?.editData?.endDateTime
          : '';
      } else {
        this.periodicDateConfig.startDateValue = this.model.startDateTime;
      }
    } catch (error) {
      this.loggerService.logError(
        this.pageName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  initForm() {
    this.form = new FormGroup({
      credit: new FormControl('', Validators.required),
      targetValue: new FormControl('', Validators.required),
      times: new FormControl('', Validators.required),
      userId: new FormControl('', Validators.required),
      startDate: new FormControl(''),
      endDate: new FormControl(''),
    });
  }

  //#region Api

  //Create
  baseCreateApi(model: CreateResellerTargetCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .resellerTargetCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateResellerTargetCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .resellerTargetUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;
      //convert date
      this.model.startDateTime = DateTimeService.toUTC(
        this.model.startDateTime
      );
      this.model.endDateTime = DateTimeService.toUTC(this.model.endDateTime);

      if (this.formPageConfig.isEditMode) this.baseUpdateApi(this.model);
      else this.baseCreateApi(this.model);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }
}
